import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/project_top.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-57f1ca77"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "project"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })], -1);
});

var _hoisted_3 = {
  class: "contbox"
};
var _hoisted_4 = ["src", "alt"];
var _hoisted_5 = {
  class: "tit"
};
var _hoisted_6 = {
  class: "cont"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("ul", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.contlist, function (item, index) {
    return _openBlock(), _createElementBlock("li", {
      class: "contitem",
      key: index
    }, [_createElementVNode("img", {
      class: "titimg",
      src: item.src,
      alt: item.tit
    }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, _toDisplayString(item.tit), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(item.con), 1)]);
  }), 128))])]);
}